module.exports = __webpack_public_path__ + "img/icon_errorpage.f9aab22.svg";